import { CollectionRepository } from '@engineering11/web-api-firebase'
import { INavFavoritesDocument } from '@employer/app/models/nav-favorites.model'
import { Injectable } from '@angular/core'
import { COLLECTIONS } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class NavFavoritesRepository extends CollectionRepository<INavFavoritesDocument> {
  protected COLLECTION: string = COLLECTIONS.NAV_FAVORITES
}
